import { render } from "./LoginAsCustomerPage.vue?vue&type=template&id=20489fdb"
import script from "./LoginAsCustomerPage.vue?vue&type=script&lang=js"
export * from "./LoginAsCustomerPage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/saas-stack/customer-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__